<template>
  <div class="_creditapplication">
    <div class="_creditapplication__topcontent">
      <img src="@/assets/image/icon/left-arrow-blue.svg" alt="">
      <span>Back</span>
    </div>
    <!-- <div class="_creditapplication__wrapper d-flex justify-content-center">
      <half-circle-spinner
        :animation-duration="1500"
        :size="100"
        color="#1D3354"
        class="mx-auto"
      />
    </div> -->
    <div class="_creditapplication__wrapper pt-2">
      <div class="_creditapplication__document">
        <div class="_creditapplication__document--head">
          <div class="row m-0 px-5 py-3">
            <div class="col-md align-items-center d-flex">
              <img src="@/assets/image/logos Andalin 2@3x.png" alt="" width="274.4">
            </div>
            <div class="col-md text-right">
              <h5>PT. EXIMKU LOGISTIK INDONESIA</h5>
              <p>Rukan Crown Palace Blok D-15 <br>
                Jl. Prof. Dr. Soepomo No. 231, Menteng Dalam Tebet, <br>
                Jakarta Selatan, DKI Jakarta 12870
              </p>
            </div>
          </div>
        </div>
        <div class="_creditapplication__document--body pb-3">
          <div class="row m-0 _tablehead_">CREDIT APPLICATION FORM</div>
          <div class="col-md m-0 _tablebody_">
            <div class="row m-0 mb-2 align-items-center">
              <div class="number">1.</div>
              <div class="col-md-2 p-0">Company Name</div>
              <b-input class="col-md-8" placeholder="Company Name"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">2.</div>
              <div class="col-md-2 p-0">Address</div>
              <b-input class="col-md-8" placeholder="Address"></b-input>
            </div>
            <div class="row m-0 mb-2 align-items-center">
              <div class="number"></div>
              <div class="col-md-2 p-0"></div>
              <div class="col-md-3 p-0">
                <div class="row m-0 align-items-center">
                    <div class="col-md-5 p-0">
                     Postal Code
                    </div>
                    <b-input class="col-md" placeholder="Postal Code"></b-input>
                </div>
              </div>
              <div class="col-md-2 text-center p-0">
                Postal Code
              </div>
              <b-input class="col-md-3" placeholder="Postal Code"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">3.</div>
              <div class="col-md-2 p-0">Telephone Number</div>
              <b-input class="col-md-3" placeholder="Telephone Number"></b-input>
              <div class="col-md-2 text-center p-0">
                 Fax Number
              </div>
              <b-input class="col-md-3" placeholder="Fax Number"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">4.</div>
              <div class="col-md-2 p-0">Contact Person</div>
              <b-input class="col-md-3" placeholder="Contact Person"></b-input>
              <div class="col-md-2 text-center p-0">
                 Contact Person A/C
              </div>
              <b-input class="col-md-3" placeholder="Contact Person A/C"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">5.</div>
              <div class="col-md-2 p-0">Designation</div>
              <b-input class="col-md-3" placeholder="Designation"></b-input>
              <div class="col-md-2 text-center p-0">
                 Telephone Number
              </div>
              <b-input class="col-md-3" placeholder="Telephone Number"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">6.</div>
              <div class="col-md-2 p-0">Email Address</div>
              <b-input class="col-md-3" placeholder="Email Address"></b-input>
              <div class="col-md-2 text-center p-0">
                 Email Address A/C
              </div>
              <b-input class="col-md-3" placeholder=" Email Address A/C"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">7.</div>
              <div class="col-md-2 p-0">NPWP Number</div>
              <b-input class="col-md-3" placeholder="NPWP Number"></b-input>
              <div class="col-md-2 text-center p-0">
                Date of Incorporation
              </div>
              <b-input class="col-md-3" placeholder="Date of Incorporation"></b-input>
            </div>
            <div class="row m-0 mb-2 mb align-items-center">
              <div class="number">8.</div>
              <div class="col-md-2 p-0">Nature of Business</div>
              <b-input class="col-md-3" placeholder="Nature of Business"></b-input>
              <div class="col-md-2 text-center p-0">
                 Number of Employee
              </div>
              <b-input class="col-md-3" placeholder=" Number of Employee"></b-input>
            </div>
            <div class="row m-0 mb-3 mb align-items-center">
              <div class="number">9.</div>
              <div class="col-md-2 p-0">Annual Revenue</div>
              <b-input class="col-md-3" placeholder="Annual Revenue"></b-input>
              <div class="col-md-2 text-center p-0">
                 Net Income After Tax
              </div>
              <b-input class="col-md-3" placeholder="Net Income After Tax"></b-input>
            </div>
            <div class="row m-0 mb-3 mb align-items-center">
              <div class="number">10.</div>
              <div class="col-md p-0">Average Volume of Shipment per Month</div>
            </div>
            <div class="col-md" style="padding-left: 100px;">
              <b-form-radio
                class="row m-0 w-100 mb-2"
                v-for="(item, i) in optionsAverageVolume"
                :key="i"
                :value="item.value"
              >
                <div class="label_shipment">
                  {{item.labelShipment}}
                </div>
                <div class="mr-3">:</div>
                <input class="col-md-1 input_average" type="number" placeholder="0">
                <div class="col-md-3">
                 {{item.labelVolume}}
                </div>
              </b-form-radio>
            </div>
            <div class="col-md options2" style="padding-left: 100px;">
              <b-form-radio class="col-md" :value="optionsAverageVolumeOthers.value">
                <div class="label_shipment mb-1">
                 {{optionsAverageVolumeOthers.labelShipment}}
                </div>
                <b-input class="col-md-5" v-model="optionsAverageVolumeOthers.value" ></b-input>
              </b-form-radio>
            </div>
            <div class="row m-0 mb-3 mb align-items-center">
              <div class="number">11.</div>
              <div class="col-md p-0">Bank Refference</div>
            </div>
            <div class="row m-0 mb-3 mb align-items-center">
              <!-- <div class="col-md-3 text-center">
                  <h1>1</h1>
              </div>
              <div class="col-md-6 text-center">
                  <h1>2</h1>
              </div> -->
              <div class="number"></div>
              <div class="col-md-2 p-0"></div>
              <h1 class="col-md-3 text-center">1</h1>
              <div class="col-md-2"></div>
              <h1 class="col-md-3 text-center">2</h1>
            </div>
            <div class="row m-0 mb-3 mb align-items-center">
              <div class="number"></div>
              <div class="col-md-2 p-0 mr-1 text-right pr-4">Bank Name</div>
              <b-input class="col-md-3" placeholder="Bank Name"></b-input>
              <div class="col-md-2 p-0 text-right pr-4">Bank Name</div>
              <b-input class="col-md-3" placeholder="Bank Name"></b-input>
            </div>
            <div class="row m-0 mb-3 mb align-items-center">
              <div class="number"></div>
              <div class="col-md-2 p-0 mr-1 text-right pr-4">Account Number</div>
              <b-input class="col-md-3" placeholder="Account Number"></b-input>
              <div class="col-md-2 p-0 text-right pr-4">Account Number</div>
              <b-input class="col-md-3" placeholder="Account Number"></b-input>
            </div>
            <div class="row m-0 mb-5 mb align-items-center">
              <div class="number"></div>
              <div class="col-md-2 p-0 mr-1 text-right pr-4">Credit Term Request</div>
              <div class="col-md-3 p-2 term_of_req">
                <div>
                  <p>Handling : 30 Days  from Invoice received</p>
                  <p>PIB : 14 Days  from Invoice received</p>
                </div>
              </div>
              <div class="col-md-2 p-0 text-right pr-4">Credit Limit</div>
              <b-textarea class="col-md-3" style="height: 70px; resize: none;" placeholder="Credit Limit"></b-textarea>
            </div>
            <div class="row m-0 mb-5 mb align-items-center">
              <div class="number"></div>
              <div class="col-md-2 p-0 mr-1 text-right pr-4">Payment Schedule</div>
              <b-input class="col-md-3" placeholder="Payment Schedule"></b-input>
            </div>
            <div class="col-md approval">
              <p>* I/we here by declare that the information given above is correct and authorize PT. Eximku Logistik Indonesia to write to our/my   banker for information pertaining to my financial status.</p>
              <p>* I/we agree to pay interest at rate of 3% per month for any late payment based on billed amount per invoice. </p>
              <p>* Failing which PT. Eximku Logistik Indonesia reserves the right to waive all further facilities given to me/company.</p>
            </div>
            <div class="row pl-3 m-0 my-5 align-items-center">
                <b style="width: 110px; ">Requested by*</b>
                <div style="width: 350px; ">
                  <b-input placeholder="Please Type Your Name Here as Your Signature"></b-input>
                </div>
            </div>
            <b class="pl-3 mb-2">Authorized Signature & Company’s Stamp</b>
            <div class="row m-0 my-2 align-items-center" style="width: 475px">
              <p class="col-md-4 mr-2">Name</p>
              <b-input class="col-md" placeholder="Name"></b-input>
            </div>
            <div class="row m-0 mb-2 align-items-center" style="width: 475px">
              <p class="col-md-4 mr-2">Position</p>
              <b-input class="col-md" placeholder="Position"></b-input>
            </div>
            <div class="row m-0 mb-2 align-items-center" style="width: 475px">
              <p class="col-md-4 mr-2">Date of Application</p>
              <b-input class="col-md" placeholder="Date of Application"></b-input>
            </div>
          </div>
          <div class="row m-0 _tablehead_">INTERNAL OFFICE USE ONLY</div>
          <div class="col-md m-0 _tablebody_">
            <div class="row m-0 mb-3 align-items-center">
              <b class="col-md-2">Assessed by*</b>
              <b-input class="col-md" placeholder="Please Type Your Name Here as Your Signature"></b-input>
              <b style="width: 170px; padding-left: 60px;">Approved by*</b>
              <b-input class="col-md" placeholder="Please Type Your Name Here as Your Signature"></b-input>
            </div>
            <div class="row m-0 mb-2 align-items-center">
              <p class="col-md-2">Name</p>
              <b-input class="col-md" placeholder="Name"></b-input>
              <p style="width: 170px; padding-left: 60px;">Name</p>
              <b-input class="col-md" placeholder="Name"></b-input>
            </div>
             <div class="row m-0 mb-2 align-items-center">
              <p class="col-md-2">Designation</p>
              <b-input class="col-md" placeholder="Position"></b-input>
              <p style="width: 170px; padding-left: 60px;">Designation</p>
              <b-input class="col-md" placeholder="Position"></b-input>
            </div>
            <div class="row m-0 mb-4 align-items-center">
              <p class="col-md-2">Date</p>
              <b-input class="col-md" placeholder="DD/MM/YY"></b-input>
              <p style="width: 170px; padding-left: 60px;">Designation</p>
              <b-input class="col-md" placeholder="DD/MM/YY"></b-input>
            </div>
            <div class="row m-0 mb-4 justify-content-end text-right">
              <p>*Required</p>
            </div>
          </div>
        </div>
        <div class="_creditapplication__document--bottom">
          <form>
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="true"
              unchecked-value="false"
              :disabled="agreement_status"
            >
              Check here to indicate that you have read and agree to the terms and of the business agreement above.
            </b-form-checkbox>
            <div class="d-flex justify-content-center">
              <button class="button__bluecorporite my-4" type="submit" :disabled="!status || status === 'false'" v-if="!agreement_status">
                <span  v-if="isLoadingBook">
                  <b-spinner small variant="light" label="Spinning" />
                </span>
                <span v-else>Save</span>
              </button>
              <button type="button" class="button__bluecorporite my-4" v-if="agreement_status">
                <span  v-if="isLoadingDownloadBA">
                  <b-spinner small variant="light" label="Spinning" />
                </span>
                <span v-else>
                  <img src = "@/assets/image/icon/download.svg" class="pr-2" @click="download()"> Download
                </span>
              </button>
              <router-link to="/request-list/rfq">
                <button type="button" class="button__bluecorporite my-4 ml-2" v-if="agreement_status">Next</button>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import moment from 'moment'

export default {
  name: 'BusinessAgreement',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      status: false,
      agreement_status: false,
      today: moment().format('YYYY-MM-DD'),
      signature: '',
      optionsAverageVolume: [
        { labelShipment: 'Import LCL Shipment', value: '', labelVolume: 'CBM/Month' },
        { labelShipment: 'Export LCL Shipment', value: '', labelVolume: 'CBM/Month' },
        { labelShipment: 'Import LCL Shipment', value: '', labelVolume: 'TEUS/Month' },
        { labelShipment: 'Export LCL Shipment', value: '', labelVolume: 'TEUS/Month' }
      ],
      optionsAverageVolumeOthers: { labelShipment: 'Other (Please Specify)', value: '' }
    }
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/CreditApplicationForm/index.vue